// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5f-0";
export var startPickingButton = "_5f-1";